import React, { useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import SoftBox from "components/SoftBox";
import PopUp from "./Component/PopUp";
import { useAppServices } from "hook/services";
import { useUploadImage } from "hook/services";
import { useNavigate } from "react-router-dom";
const { v4: uuidv4 } = require("uuid");
import deleteIcon from "../../../../../assets/themeIcons/delete-icon.svg";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import viewIcon from "../../../../../assets/themeIcons/eye-view.svg";
import { uploadImageToGhl } from "hook/services";
import toast from "react-hot-toast";
import { useAgencyInfo } from "context/agency";
import ReactCropModal from "layouts/super-admin/settings/Configurator/components/ReactCropModal/ReactCropModal";
import img_empty from "assets/images/img.jpg"; // Added default image import

function JobsTab({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const uploadImage = useUploadImage();
  const [success, setSuccess] = useState("");
  const [popup, setPopup] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [loading, setLoading] = useState(false);
  const [jobsData, setJobsData] = useState([]);
  const quillRef = useRef(null);
  const quillInstance = useRef(null);
  const navigate = useNavigate();
  const [agency] = useAgencyInfo();
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [tempImageFile, setTempImageFile] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);

  const getJobs = async (e) => {
    const { response } = await AppService.jobs.Get({
      query: `account_id=${formData._id}`,
    });
    setJobsData(response?.data);
  };

  const [applicantsPopup, setApplicantsPopup] = useState(false);
  const [applicants, setApplicants] = useState([]);

  const closeApplicantsPopup = () => setApplicantsPopup(false);

  useEffect(() => {
    if (popup) {
      setTimeout(() => {
        if (quillRef.current && !quillInstance.current) {
          quillInstance.current = new Quill(quillRef.current, {
            theme: "snow",
          });
        }
        if (selectedJob && quillInstance.current) {
          quillInstance.current.root.innerHTML = selectedJob.description || "";
        }
      }, 100);
    }
    return () => {
      if (!popup && quillInstance.current) {
        quillInstance.current = null;
      }
    };
  }, [popup, selectedJob]);

  const openPopup = () => setPopup(true);
  const closePopup = () => {
    setPopup(false);
    setSelectedJob(null);
    quillInstance.current = null;
  };

  const openCropModal = (file) => {
    setTempImageFile(file);
    setCurrentImage(URL.createObjectURL(file));
    setCropModalOpen(true);
  };

  const handleCroppedImage = async (blob) => {
    if (!blob) return;

    setImageUploading(true);
    try {
      const file = new File([blob], "cropped-job-image.jpg", { type: "image/jpeg" });
      const image_response = await uploadImageToGhl(file, agency);

      if (image_response?.data) {
        // Update the form with the new image URL
        if (selectedJob) {
          setSelectedJob(prev => ({
            ...prev,
            image: image_response.data
          }));
        }
        setTempImageFile(null);
        toast.success("Image uploaded successfully!");
      }
    } catch (err) {
      console.error("Image upload failed:", err);
      toast.error("Failed to upload image");
    } finally {
      setImageUploading(false);
      setCropModalOpen(false);
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      openCropModal(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const description = quillInstance.current ? quillInstance.current.root.innerHTML.trim() : "";

    const image = e.target?.image?.files[0];
    let image_url = selectedJob?.image || "";

    // If a new image was selected and cropped, it would be in selectedJob.image
    if (image && !selectedJob?.image) {
      const imageResponse = await uploadImageToGhl(image, agency);
      image_url = imageResponse?.data || "";
    }

    const payload = {
      title: e.target?.title?.value,
      location: e.target?.location?.value,
      image: image_url,
      phone: e.target?.phone?.value,
      email: e.target?.email?.value,
      website: e.target?.website?.value,
      description,
      account_id: formData?._id,
      agency_id: formData?.agency_id,
    };

    let response;

    if (selectedJob) {
      response = await AppService.jobs.Update({
        payload: { ...payload, _id: selectedJob._id },
      });
    } else {
      response = await AppService.jobs.Create({ payload });
    }

    if (response) {
      handleRefresh();
      setPopup(false);
      setSelectedJob(null);
      getJobs();
      toast.success(selectedJob ? "Job updated successfully!" : "New job created successfully!");
    } else {
      toast.error("Error updating Data");
    }

    setLoading(false);
  };

  const editJob = (job) => {
    setSelectedJob(job);
    if (quillInstance.current) {
      quillInstance.current.root.innerHTML = job.description || "";
    }
    openPopup();
  };

  const deleteJob = async (job) => {
    const { response } = await AppService.jobs.Delete({
      toaster: true,
      query: `_id=${job._id}`,
    });

    if (response) {
      handleRefresh();
      getJobs(); // Refresh the jobs list
      toast.success("Delete Successfully");
    } else {
      toast.error("Error deleting attachment");
    }
  };

  useEffect(() => {
    getJobs();
  }, [formData]);

  return (
    <div>
      <p className="text-center">{success}</p>
      <div style={{ display: "flex", justifyContent: "end", margin: "0 10px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={openPopup}
          style={{ color: "white", background: "black" }}
        >
          New Job
        </Button>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {jobsData?.map((job, index) => (
          <SoftBox
            key={index}
            style={{
              margin: "10px",
              width: "30%",
              borderRadius: "10px",
              border: "1px solid #f5f5f5",
              padding: "10px",
            }}
          >
            <div style={{ display: "", justifyContent: "space-between" }}>
              <h4>{job.title}</h4>
            </div>
            <p>
              <b>Description:</b>{" "}
              {job.description
                .replace(/<[^>]*>?/gm, "")
                .split(" ")
                .slice(0, 20)
                .join(" ")}
              ...
            </p>
            <p>
              <b>Location:</b> {job.location}
            </p>
            <p>
              <b>Phone:</b> {job.phone}
            </p>
            <p>
              <b>Email:</b> {job.email}
            </p>
            <p>
              <b>Website:</b>{" "}
              <a href={job?.website} target="_blank" rel="noopener noreferrer">
                {job.website}
              </a>
            </p>
            <img
              src={job?.image || img_empty}
              alt="Job"
              style={{ 
                width: "100%", 
                height: "200px", 
                objectFit: "cover",
                borderRadius: "8px"
              }}
            />

            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
              <Button
                variant="contained"
                color="white"
                onClick={() =>
                  navigate(`../job-detail/${job._id}`, {
                    state: { job },
                  })
                }
                style={{ minWidth: "auto", padding: "8px" }}
              >
                <img src={viewIcon} width={25} style={{ cursor: "pointer" }} alt="View" />
              </Button>
              <Button 
                variant="contained" 
                color="white" 
                onClick={() => editJob(job)}
                style={{ minWidth: "auto", padding: "8px" }}
              >
                <img src={editIcon} width={20} style={{ cursor: "pointer" }} alt="Edit" />
              </Button>
              <Button
                variant="contained"
                color="white"
                style={{ 
                  background: "#e44d36", 
                  color: "#fff",
                  minWidth: "auto", 
                  padding: "8px" 
                }}
                onClick={() => deleteJob(job)}
              >
                <img src={deleteIcon} width={20} style={{ cursor: "pointer" }} alt="Delete" />
              </Button>
            </div>
          </SoftBox>
        ))}
      </div>

      <PopUp open={popup} handleClose={closePopup} title={selectedJob ? "Edit Job" : "Add Job"}>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "33%", padding: "10px" }}>
              <SoftBox>
                <label className="text-black">Title</label>
                <input
                  className="form-control-agust"
                  name="title"
                  type="text"
                  placeholder="Title"
                  defaultValue={selectedJob?.title || ""}
                  required
                />
              </SoftBox>
            </div>
            <div style={{ width: "33%", padding: "10px" }}>
              <SoftBox>
                <label className="text-black">Location</label>
                <input
                  className="form-control-agust"
                  name="location"
                  type="text"
                  placeholder="Location"
                  defaultValue={selectedJob?.location || ""}
                  required
                />
              </SoftBox>
            </div>
            <div style={{ width: "33%", padding: "10px" }}>
              <SoftBox>
                <label className="text-black">Image</label>
                <input 
                  className="form-control-agust" 
                  name="image" 
                  type="file" 
                  accept="image/*"
                  onChange={handleImageUpload}
                />
                {selectedJob?.image && (
                  <div style={{ marginTop: "10px" }}>
                    <img
                      src={selectedJob.image}
                      alt="Current job"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "8px"
                      }}
                    />
                  </div>
                )}
              </SoftBox>
            </div>
          </div>

          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ width: "33%", padding: "10px" }}>
              <SoftBox>
                <label className="text-black">Phone Number</label>
                <input
                  className="form-control-agust"
                  name="phone"
                  type="number"
                  placeholder="Phone Number"
                  defaultValue={selectedJob?.phone || ""}
                  required
                />
              </SoftBox>
            </div>
            <div style={{ width: "33%", padding: "10px" }}>
              <SoftBox>
                <label className="text-black">Email</label>
                <input
                  className="form-control-agust"
                  name="email"
                  type="email"
                  placeholder="Email"
                  defaultValue={selectedJob?.email || ""}
                  required
                />
              </SoftBox>
            </div>
            <div style={{ width: "33%", padding: "10px" }}>
              <SoftBox>
                <label className="text-black">Website</label>
                <input
                  className="form-control-agust"
                  name="website"
                  type="text"
                  placeholder="Website URL"
                  defaultValue={selectedJob?.website || ""}
                />
              </SoftBox>
            </div>
          </div>

          <div style={{ padding: "10px" }}>
            <SoftBox>
              <label className="text-black">Description</label>
              <div ref={quillRef} style={{ height: "200px", marginBottom: "20px" }} />
            </SoftBox>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              margin: "0 10px",
            }}
          >
            <Button
              variant="contained"
              type="submit"
              color="primary"
              disabled={loading || imageUploading}
              style={{ color: "white", background: "black" }}
            >
              {loading ? "Processing..." : selectedJob ? "Update Job" : "Save Job"}
            </Button>
          </div>
        </form>
      </PopUp>

      <PopUp
        open={applicantsPopup}
        handleClose={closeApplicantsPopup}
        title="Applicants"
        style={{ with: "70%" }}
      >
        <div
          style={{ padding: "16px", backgroundColor: "#f9f9f9", borderRadius: "8px", with: "70%" }}
        >
          {applicants.length > 0 ? (
            <ul style={{ listStyle: "none", padding: "0", margin: "0" }}>
              {applicants.map((applicant, index) => (
                <li
                  key={index}
                  style={{
                    padding: "12px",
                    margin: "8px 0",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#333",
                    }}
                  >
                    Name: {applicant.account_id.first_name} {applicant.account_id.last_name}
                  </span>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#555",
                    }}
                  >
                    Business Name: {applicant.account_id.business_name}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p
              style={{
                fontSize: "14px",
                color: "#999",
                textAlign: "center",
              }}
            >
              No applicants available for this job.
            </p>
          )}
        </div>
      </PopUp>

      <ReactCropModal
        open={cropModalOpen}
        onClose={() => setCropModalOpen(false)}
        currentImage={currentImage}
        onCropComplete={handleCroppedImage}
        aspectRatio={16/9}
      />
    </div>
  );
}

export default JobsTab;